module.exports = function(num){
    if (!isNaN(num)){
        return num.toString(10)+'px';
    }
    return num;
}


//////////////////
// WEBPACK FOOTER
// ../~/add-px/index.js
// module id = 607
// module chunks = 0